/* eslint-disable */
import React from "react";
import { Card, Title, Divider, Text } from "@mantine/core";

export default function RetentionCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Retention of Your Personal Data</Title>
      <Divider my="md" />
      <Text>
        The Company will retain Your Personal Data only for as long as is
        necessary for the purposes set out in this Privacy Policy. We will
        retain and use Your Personal Data to the extent necessary to comply with
        our legal obligations (for example, if we are required to retain your
        data to comply with applicable laws), resolve disputes, and enforce our
        legal agreements and policies.
      </Text>
      <Text mt="sm">
        The Company will also retain Usage Data for internal analysis purposes.
        Usage Data is generally retained for a shorter period of time, except
        when this data is used to strengthen the security or to improve the
        functionality of Our Service, or We are legally obligated to retain this
        data for longer time periods.
      </Text>
    </Card>
  );
}
